// extracted by mini-css-extract-plugin
export default {"container":"_-_-record-it-components-src-grid-Grid-__container"};